import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Text, getPaletteColor, Relative } from 'pcln-design-system'

import airTheme from '../AirThemeProvider/airTheme'

/**
 * Presently this is just for the AIR_BEC_VISUAL_2 SETI test
 * but feel free to modify it for the price strikethrough if that wins
 * or any other strikethrough stuff we need
 * */

const StrikeThroughWrapper = styled(Text)`
  display: inline-block;
  position: relative;
  font-size: 12px;
  line-height: 12px;
  color: ${getPaletteColor('text.light')};

  ${(props) => props.theme.flyQueries.tablet} {
    font-size: 14px;
  }

  ${(props) => props.theme.flyQueries.desktoplg} {
    text-align: center;
  }
`

const BoxStrikeThroughWrapper = styled(Relative)`
  font-size: 12px;
  line-height: 12px;
`

const StrikeSVG = styled.svg`
  position: absolute;
  left: 0;
  height: 100%;
  width: 100%;

  & > line.pcln-strikethrough-line {
    stroke: ${(props) => getPaletteColor(props.color)(props)};
  }
`

const StrikeThrough = ({ children, color, strokeWidth, allowHorizontalAlignment }) => {
  const Wrapper = allowHorizontalAlignment ? BoxStrikeThroughWrapper : StrikeThroughWrapper
  return !children ? null : (
    <Wrapper>
      <StrikeSVG viewBox='0 0 32 32' color={color}>
        <line className='pcln-strikethrough-line' x1='0' y1='0' x2='32' y2='32' strokeWidth={strokeWidth} />
      </StrikeSVG>
      {children}
    </Wrapper>
  )
}

StrikeThroughWrapper.defaultProps = {
  theme: airTheme,
}

StrikeSVG.defaultProps = {
  theme: airTheme,
}

StrikeThrough.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  strokeWidth: PropTypes.string,
  allowHorizontalAlignment: PropTypes.bool,
}

StrikeThrough.defaultProps = {
  theme: airTheme,
  color: 'error.base',
  strokeWidth: '1',
}

export default StrikeThrough
